export default function EmptyState({ icon, title, subtitle, action }) {
  return (
    <div className="h-full flex items-center justify-center" style={{ backgroundColor: 'var(--color-bg-primary)' }}>
      <div className="text-center">
        <svg className="w-16 h-16 mx-auto mb-4" style={{ color: 'var(--color-text-disabled)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={icon} />
        </svg>
        <p className="text-lg" style={{ color: 'var(--color-text-primary)' }}>{title}</p>
        {subtitle && <p className="text-sm mt-2" style={{ color: 'var(--color-text-muted)' }}>{subtitle}</p>}
        {action && (
          <button
            onClick={action.onClick}
            className="mt-6 px-6 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 mx-auto"
            style={{
              backgroundColor: 'var(--color-accent-primary)',
              color: '#ffffff'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = '0.9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = '1';
            }}
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            <span>{action.label}</span>
          </button>
        )}
      </div>
    </div>
  );
}
